import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const usePlaceState = () => React.useContext(Context)
export const usePlace = () => usePlaceState()?.place

const QUERY = gql`
  query Place($id: ID) {
    place(id: $id, filter: { includeDisabled: true, ignoreSegments: true }) {
      id
      name
      resume
      type
      placeLevelsResume
      fieldValues {
        id
        value
        fieldId
      }
    }
  }
`

const UsersLoader = ({ children }) => {
  const { id } = useModalData()
  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: placesClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default UsersLoader
